import PropTypes from 'prop-types'

// Internal components
import Svg from '../Svg/Svg'

const AccountBadge = (props) => {
  const { initials, icon, modifiers } = props

  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''

  return (
    <span
      className={`AccountBadge${modifierClasses}${icon ? ' AccountBadge--icon' : ''}${
        initials !== '' || icon ? ' is-loaded' : ''
      }`}
    >
      {icon ? <Svg modifiers={['AccountBadge-icon']} id={icon} /> : initials || ''}
    </span>
  )
}

AccountBadge.propTypes = {
  initials: PropTypes.any,
  icon: PropTypes.any,
  modifiers: PropTypes.any
}

export default AccountBadge
